import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Toasted from 'vue-toasted'
import VueClipboard from 'vue-clipboard2'

Vue.use(Toasted)
Vue.use(VueClipboard)
const options = {
  className: 'error-toast',
  duration: 5000,
  action: {
    text: 'dismiss',
    onClick: (e, toastObject) => {
      toastObject.goAway(0)
    }
  }
}

const successToastOptions = {
  className: 'success-toast',
  duration: 5000,
  action: {
    text: 'dismiss',
    onClick: (e, toastObject) => {
      toastObject.goAway(0)
    }
  }
}

const warningToastOptions = {
  className: 'warning-toast',
  duration: 5000,
  action: {
    text: 'dismiss',
    onClick: (e, toastObject) => {
      toastObject.goAway(0)
    }
  }
}

Vue.toasted.register('web_service_error',
  (payload) => {
    if (!payload.message) {
      return 'Oops.. Something Went Wrong..'
    }
    return payload.message
  },
  options
)

Vue.toasted.register('success_toasted',
  (msg) => {
    return msg.message
  },
  successToastOptions
)

Vue.toasted.register('warning_toasted',
  (msg) => {
    return msg.message
  },
  warningToastOptions
)

Vue.toasted.register('training_file_process_error_toasted',
  (msg) => {
    return msg.message
  },
  options
)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
